/* eslint-disable react/prop-types */
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, Grid } from '@mui/material';

const AccessData = ({ data }) => (
    <>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <strong>Name</strong>
                        </TableCell>
                        <TableCell>
                            <strong>Role</strong>
                        </TableCell>
                        <TableCell>
                            <strong>Email</strong>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((e) => (
                        <TableRow key={`accessData${e?.id}`}>
                            <TableCell>
                                <Typography variant="body1">{`${e?.user?.firstName} ${e?.user?.lastName}`}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body1">{e?.user?.roleName}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body1">{e?.user?.email}</Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        {data.length <= 0 && (
            <Box sx={{ width: '100%', minHeight: '5rem', textAlign: 'center', verticalAlign: 'center' }}>
                <Typography variant="h4" color="textSecondary" sx={{ mt: 4 }}>
                    No data available
                </Typography>
            </Box>
        )}
    </>
);

export default AccessData;
